/**
 * Collaborations Marquee — GSAP-powered infinite horizontal scroll
 * 
 * Architecture:
 *  - Two identical .collab-marquee__track elements placed side-by-side
 *  - Both tracks are translated left continuously; when one exits the viewport,
 *    the GSAP repeat mechanism resets the position seamlessly
 *  - Hover slows the tween to 50% speed with a power1.out ease (organic feel)
 *  - Mouse leave eases back to 100% speed
 */ (function() {
    'use strict';
    // Wait for DOM + GSAP to be ready
    function initMarquee() {
        var wrapper = document.getElementById('marqueeWrapper');
        if (!wrapper) return;
        var tracks = wrapper.querySelectorAll('.collab-marquee__track');
        if (tracks.length < 2) return;
        // Measure the width of one track (all company names)
        var trackWidth = tracks[0].offsetWidth;
        // Duration in seconds for one full cycle — adjust for desired speed
        // Longer = slower, shorter = faster
        var baseDuration = 30;
        // Create infinite scrolling tween
        // Move both tracks leftward by one trackWidth, then repeat
        var tween = gsap.to(tracks, {
            x: -trackWidth,
            duration: baseDuration,
            ease: 'none',
            repeat: -1,
            modifiers: {
                // Use modifiers to wrap the x position for true seamless looping
                x: gsap.utils.unitize(function(x) {
                    return parseFloat(x) % trackWidth;
                })
            }
        });
        // ─── Hover: slow down to 50% speed (desktop only) ──────────────────────
        var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        if (!isTouchDevice) {
            wrapper.addEventListener('mouseenter', function() {
                gsap.to(tween, {
                    timeScale: 0.5,
                    duration: 0.6,
                    ease: 'power1.out',
                    overwrite: true
                });
            });
            // ─── Mouse leave: return to 100% speed ─────────────────────────────
            wrapper.addEventListener('mouseleave', function() {
                gsap.to(tween, {
                    timeScale: 1,
                    duration: 0.6,
                    ease: 'power1.out',
                    overwrite: true
                });
            });
        }
        // ─── Touch: slow on touchstart, resume on touchend ────────────────────
        if (isTouchDevice) {
            wrapper.addEventListener('touchstart', function() {
                gsap.to(tween, {
                    timeScale: 0.15,
                    duration: 0.4,
                    ease: 'power1.out',
                    overwrite: true
                });
            }, {
                passive: true
            });
            wrapper.addEventListener('touchend', function() {
                gsap.to(tween, {
                    timeScale: 1,
                    duration: 0.6,
                    ease: 'power1.out',
                    overwrite: true
                });
            }, {
                passive: true
            });
        }
        // ─── Handle resize: recalculate track width ────────────────────────
        var resizeTimeout;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function() {
                var newTrackWidth = tracks[0].offsetWidth;
                if (newTrackWidth !== trackWidth) {
                    trackWidth = newTrackWidth;
                    tween.kill();
                    tween = gsap.to(tracks, {
                        x: -trackWidth,
                        duration: baseDuration,
                        ease: 'none',
                        repeat: -1,
                        modifiers: {
                            x: gsap.utils.unitize(function(x) {
                                return parseFloat(x) % trackWidth;
                            })
                        }
                    });
                }
            }, 250);
        });
    }
    // Initialize when DOM is ready
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMarquee);
    else // Small delay to ensure layout is painted and measurements are accurate
    requestAnimationFrame(function() {
        requestAnimationFrame(initMarquee);
    });
})();

//# sourceMappingURL=Personal_Portfolio_2023.3675f43f.js.map
